import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import React from "react";
var ContentModule = function(param) {
    var content = param.content, renderCondition = param.renderCondition;
    return(// eslint-disable-next-line react/jsx-no-useless-fragment
    renderCondition ? /*#__PURE__*/ _jsx(_Fragment, {
        children: content
    }) : null);
};
export { ContentModule };
